import React from 'react';
import { Blog, Footer, Header, Info, Testimonials, Topic } from './components';

export default function App() {
  return (
    <>
      <Header />
      <Topic />
      <Info />
      <Blog />
      <Testimonials />
      <Footer />
    </>
  );
}
